module.exports = __webpack_public_path__ + "static/media/headquarters.47d0261e.jpg";